export * from './base-user-info/base-user-info.interface';
export * from './bind-user-info/bind-user-info.interface';
export * from './vip-user-info/vip-user-info.interface';
export * from './official-info/official-info.interface';
export var NOT_LOGIN_TINYID = '100000000000000000';
